import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CBadge,CCard,CCardBody,CButton,CCardHeader,CCol,
  CDataTable,CDropdown, CDropdownToggle, CDropdownMenu,
  CRow,CPagination,CModal,CModalHeader,CModalBody,
  CModalFooter,CForm,CFormGroup,CFormText, CDropdownItem,
  CLabel,CInput,CInputGroup,CInputGroupText
} from 'compat/coreui'
import { ToastContainer, toast } from 'react-toastify';

import axios from 'axios';
import moment from 'moment';

const getBadge = status => {
  switch (status) {
    case 'Active': return 'success'
    case 'Inactive': return 'secondary'
    case 'Pending': return 'warning'
    case 'Banned': return 'danger'
    default: return 'primary'
  }
}


const Products = () => {
  const history = useNavigate()
  const [modal, setModal] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [productImage, setProductImage] = useState('');
  const [thc, setThc] = useState('');
  const [cbd, setCbd] = useState('');
  const [cbn, setCbn] = useState('');
  const [price, setPrice] = useState('');
  const [priceHalf, setPriceHalf] = useState('');
  const [priceForth, setPriceForth] = useState('');
  const [priceEight, setPriceEight] = useState('');
  const [priceOz, setPriceOz] = useState('');
  const [status, setStatus] = useState('active');
  const [preOrder, setPreOrder] = useState(1);
  const [productsData, setProductsData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [sCatId, setSelectedCat] = useState('');


  const toggle = ()=>{
    setModal(!modal);
  }

  useEffect(async () => {
    getData();
    getProduct();
  }, [])

  const getProduct = () => {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/menuitem`,{
      headers: {
        'Authorization': 'Bearer '+localStorage.getItem('token')}
    }).then(res => {
      setProductsData(res.data.list);
    }).catch(e => console.log(e))
  }


  function getData() {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/category`,{
      headers: {
        'Authorization': 'Bearer '+localStorage.getItem('token')}
    }).then(res => {
      setCategoryData(res.data.list);
    }).catch(e => console.log(e))
  }
  const addProducts = (e) => {
    e.preventDefault();
    e.target.reset();

    const token = localStorage.getItem('token');
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/menuitem`,
      method: 'POST',
      headers: {
        'Authorization': 'Bearer '+token
      },
      data: {
          "name": name,
          "description": description,
          "image": null,
          "image": null,
          "thc": thc,
          "cbd": cbd,
          "cbn": cbn,
          "price": price,
          "priceHalf": priceHalf,
          "priceForth": priceForth,
          "priceEight": priceEight,
          "priceOz": priceOz,
          "status": status,
          "preOrder": preOrder,
          "category": sCatId,
      }
    }).then(response => {
        if(response.data.status){
          setModal(false);
          getProduct();
          toast.success('Product added successfully')
        }
      }).catch(console.log)
  }
  return (
    <CRow className="product_page">
      <CCol xl={12}>
        <CCard>
          <CCardHeader className="category_header">
            Products
          <CButton
            onClick={toggle}
            className="mr-1"
            color="success"
          >Add Products</CButton>
          </CCardHeader>
          <CCardBody>

            <div className="table-responsive"
            >
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Product Name</th>
                    <th>Product Category</th>
                    <th>Price</th>
                    <th>Status</th>
                    <th>Pre-order</th>
                  </tr>
                </thead>
                  <tbody>
                    {productsData.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.category === null ? '-' : item.category.title}</td>
                            <td>{item.price}</td>
                            <td><CBadge style={{padding: "0.8em 1.3em"}} color={item.status === "active" ? "success" : "danger"}>{item.status.toUpperCase()}</CBadge></td>
                            <td>{item.preOrder === 1 ? "AVAILABLE" : 'NOT AVAILABLE'}</td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CModal
        show={modal}
        onClose={toggle}
      >
        <CModalHeader closeButton>Add Products</CModalHeader>
        <CModalBody>
          <form onSubmit={addProducts}>
            <CFormGroup className="category_header">
              <CCol xl={6} className="pl-0">
                <CLabel htmlFor="nf-title">Category</CLabel>
                <CDropdown>
                  <select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setSelectedCat(e.target.value)}>
                     {categoryData.map((cat, index) => {
                        return (<option key={index} value={cat._id}>{cat.title}</option>);
                      })}
                  </select>
                </CDropdown>
              </CCol>
              <CCol xl={6} className="pr-0">
              <CLabel htmlFor="nf-title">Products Name</CLabel>
              <CInput
                type="text"
                id="nf-name"
                name="nf-name"
                placeholder="Enter name.."
                value={name}
                onChange={e => setName(e.target.value)}
              />
              {/*<CFormText className="help-block">Please enter Products name</CFormText>*/}
              </CCol>
            </CFormGroup>
            <CFormGroup>
              <CLabel htmlFor="nf-description">Item Description</CLabel>
              <CInput
                type="text"
                id="nf-description"
                name="nf-description"
                placeholder="Enter description.."
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
              {/*<CFormText className="help-block">Please enter sub Products</CFormText>*/}
            </CFormGroup>
            <CFormGroup className="d-flex ">
              <div className="col-lg-5 pl-0">
                <CLabel htmlFor="nf-product_image">Item Photo</CLabel>
                <div className="product_wrap">
                  <div className="p_img">
                    <i className="fa fa-camera" aria-hidden="true"></i>
                  </div>
                  <div>
                    <div className="fileUpload">
                      <span>Upload a Photo</span>
                      <CInput type="file" className="upload" />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <CLabel htmlFor="nf-product_image">Lab Tested Result</CLabel>
                <div className="d-flex">
                  <CInput type="text" name="THC" className="THC" onChange={(e) => setThc(e.target.value)}/><span style={{padding:'5px',fontSize:'12px'}}>THC%</span>
                  <CInput type="text" name="CBD" className="CBD" onChange={(e) => setCbd(e.target.value)}/><span style={{padding:'5px',fontSize:'12px'}}>CBD%</span>
                  <CInput type="text" name="CBN" className="CBN" onChange={(e) => setCbn(e.target.value)}/><span style={{padding:'5px',fontSize:'12px'}}>CBN%</span>
                </div>
              </div>
            </CFormGroup>

            <CFormGroup>
                <CLabel htmlFor="nf-pricing">Pricing</CLabel>
                <div className="d-flex">
                  <div className="p-1">
                    <CLabel htmlFor="nf-pricing" style={{background: 'lightgray', padding: '3px 35px'}} >g</CLabel>
                    <CInput type="text" name="price" className="price" onChange={(e) => setPrice(e.target.value)}/>
                  </div>
                  <div className="p-1">
                    <CLabel htmlFor="nf-pricing" style={{background: 'lightgray', padding: '3px 35px'}}>1/8</CLabel>
                    <CInput type="text" name="priceEight" className="priceEight" onChange={(e) => setPriceEight(e.target.value)}/>
                  </div>
                  <div className="p-1">
                    <CLabel htmlFor="nf-pricing" style={{background: 'lightgray', padding: '3px 35px'}}>1/4</CLabel>
                    <CInput type="text" name="priceForth" className="price" onChange={(e) => setPriceForth(e.target.value)}/>
                  </div>
                  <div className="p-1">
                    <CLabel htmlFor="nf-pricing" style={{background: 'lightgray', padding: '3px 35px'}}>1/2</CLabel>
                    <CInput type="text" name="priceHalf" className="priceHalf" onChange={(e) => setPriceHalf(e.target.value)}/>
                  </div>
                  <div className="p-1">
                    <CLabel htmlFor="nf-pricing" style={{background: 'lightgray', padding: '3px 35px'}}>oz</CLabel>
                    <CInput type="text" name="priceOz" className="price" onChange={(e) => setPriceOz(e.target.value)}/>
                  </div>
                </div>
            </CFormGroup>
            <CFormGroup className="category_header">
              <CCol xl={6} className="pl-0">
                <CLabel htmlFor="nf-title">Status</CLabel>
                <CDropdown>
                  <select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setStatus(e.target.value)}>
                     <option value="active">Active</option>
                     <option value="disable">Inactive</option>
                  </select>
                </CDropdown>
              </CCol>
              <CCol xl={6} className="pr-0">
                <CLabel htmlFor="nf-title">Pre-order Online</CLabel>
                <CDropdown className="btn-lg" style={{padding: '0px'}}>
                  <select className="custom-select my-1 mr-sm-2 product_status" onChange={(e) => setPreOrder(e.target.value)}>
                     <option value={1}>Available</option>
                     <option value={2}>Not Available</option>
                  </select>
                </CDropdown>
              </CCol>
              </CFormGroup>
              <div className="d-flex">
                <CInput type="checkbox" className="addCheckbox mr-2"/>
                <CLabel htmlFor="add_another" className="mt-2">Add Another</CLabel>
              </div>
              <CButton color="primary" type="submit">Save</CButton>{' '}
              <CButton
                color="secondary"
                onClick={toggle}>
                  Cancel
              </CButton>
          </form>
        </CModalBody>
      </CModal>
    </CRow>
  )
}

export default Products;
